import { quizOwnerTariffStateFields } from "@/graphql/fragments/query/tariffs.fragments";

export const fragmentQuizzesDataForQuizWidget = `
    fragment FragmentQuizzesDataForQuizWidget on QuizPagination {
         data {
           id
           code
           name
           domain
           embed_domains
           options { 
              id
              corners
              theme
              show_progress
              custom_privacy_policy_url
              custom_design
           }
           settings
         }
    }
`;
export const fragmentQuizzesDataForSettingsAdmin = `
    fragment fragmentQuizzesDataForSettingsAdmin on QuizPagination {
        data {
            id
            code
            name
            domain
            is_template
            tags
            is_blocked
            viewer_permissions {
                is_owner
            }
             contact_page { 
                id 
                header
            }

            options { 
                id
                corners
                theme
            }

            start_page{
                id
                header
            }
                        
            questions { 
                id
                text
            }

            finish_page {
                id
                header
            }
        }
    }
`;
export const fragmentQuizzesDataForConstructorSettings = `
    fragment fragmentQuizzesDataForConstructorSettings on QuizPagination {
          data {
              id
              code
              timezone
              name
              project_id
              is_shared
              viewer_permissions {
                  is_owner
                  is_collaborator
                  can_manage_quiz
                  can_copy
                  can_manage_integrations
                  can_view_crm
                  can_share
                  can_transfer
                  can_delete
                  can_publish
              }
              ${quizOwnerTariffStateFields}
              domain
              embed_domains
              feature_usage
              integrations {
                  id
                  class
                  type {id}
                 sort
                 active
             }
             options { 
                 id
                 corners
                 theme
                 show_progress
                 lang
                 hide_label
                 auto_next
                 auto_redirect
                 auto_redirect_url
                 show_back_button
                 custom_privacy_policy_url
                 qr_code {
                  utm_source
                  utm_medium
                  utm_campaign
                  utm_term
                  utm_content
                }
                 spam_filter {
                     enabled
                     lead_limit_by_user
                 }
                 benefits {
                     start_page
                     questions
                     contact_page
                     finish_page
                }
             }
        }
    }
`;
export const fragmentQuizzesDataForConstructorSteps = `
    fragment fragmentQuizzesDataForConstructorSteps on QuizPagination {
          data {
              id
              code
              name
              project_id
              is_shared
              viewer_permissions {
                  is_owner
                  is_collaborator
                  can_manage_quiz
                  can_copy
                  can_manage_integrations
                  can_view_crm
                  can_share
                  can_transfer
                  can_delete
                  can_publish
              }
              ${quizOwnerTariffStateFields}
              timezone
              domain
              points_min
              points_max
              contacts
              logotype{
                  id
                  filename
                  storage
                  unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                  path
                  type
                  size
                  hint
                  created_at
              }
              options { 
                  id
                  corners
                  theme
                  show_progress
                  lang
                  hide_label
                  auto_next
                  auto_redirect
                  auto_redirect_url
                  animation
                  privacy_policy_request
                  show_back_button
                  custom_design
                  points {
                      enabled
                      show_each_page
                      formula
                  }

                  benefits {
                      start_page
                      questions
                      contact_page
                      finish_page
                  }
              }

              social_networks {
                  id
                  network_type
                  network_url
              }
                          
              benefits {
                  id
                  type
                  image {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                  }
                  label
                  description
                  benefit
              }

              consultants {
                  id
                  name
                  job_title
                  created_at
                  votes
                  photo {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                      display_settings {
                          desktop {background_size horizontal_position vertical_position}
                          mobile {background_size horizontal_position vertical_position}
                      }
                  }
                  display_conditions {
                      logic
                      answers {
                          question_id
                          logic
                          value
                      }
                  }
              }

              start_page{
                  id
                  hidden
                  format
                  photo {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                      display_settings {
                          desktop {background_size horizontal_position vertical_position}
                          mobile {background_size horizontal_position vertical_position}
                      }
                  }
                  mobile_photo {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                      display_settings {
                          mobile {background_size horizontal_position vertical_position}
                      }
                  }
                  header
                  description
                  button_text
              }

              questions { 
                  id
                  hidden
                  answer_type
                  options {
                      ...on VariantProperties {
                          auto_next
                          display_mode
                          show_custom
                          multiple
                          view
                      }
                      ...on RangeProperties {
                          minimum
                          maximum
                          step
                          is_range
                          position_start
                          position_end
                      }
                      ... on SimplePageProperties{
                          additional_text
                      }
                      ...on RatingProperties {
                          count
                          display
                          border_style
                          color_ids
                          pack_id
                          size_id
                          titles
                      }
                      ...on MultiInputProperties {
                              display_options {
                                layout
                                columns
                              }
                              inputs {
                                config {
                                  mask_id
                                  label
                                  options {
                                    label
                                    value
                                    description
                                  }
                                }
                                key
                                placeholder
                                required
                                title
                                type
                                ui {
                                  sort
                                  hidden
                                }
                              }
                            }
                      ... on CustomProperties{
                          placeholder
                          mask_id
                          display_mode_custom:display_mode
                      }
                      ... on TextareaProperties{
                          placeholder
                      }
                      ...on DateTimeProperties {
                          display_mode_datetime: display_mode
                          min_date
                          max_date
                          min_time
                          max_time
                          format
                          is24
                          is_range
                          prohibit_days_of_week
                      }
                       ...on RatingProperties {
                            display
                            count
                            border_style
                            color_ids
                            pack_id
                            size_id
                            titles
                      }
                      ...on MultiInputProperties {
                              display_options {
                                layout
                                columns
                              }
                              inputs {
                                config {
                                  mask_id
                                  label
                                  options {
                                    label
                                    value
                                    description
                                  }
                                }
                                key
                                placeholder
                                required
                                title
                                type
                                ui {
                                  sort
                                  hidden
                                }
                              }
                            }
                  }
                  display_conditions {
                      logic
                      answers {
                          question_id
                          logic
                          value
                      }
                  }
                  points_conditions {
                      logic
                      answers {
                          question_id
                          logic
                          value
                          points
                      }
                  }
                  placeholder
                  show_consultant
                  photo {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                      display_settings {
                          desktop {background_size horizontal_position vertical_position}
                          mobile {background_size horizontal_position vertical_position}
                      }
                  }
                  mobile_photo {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                      display_settings {
                          mobile {background_size horizontal_position vertical_position}
                      }
                  }
                  video {
                      allow_fullscreen
                      autoplay
                      controls
                      ratio
                      url
                      enabled
                  }
                  text
                  description
                  variants { 
                      id
                      photo {
                          id
                          filename
                          storage
                          unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                          hint
                      }
                      answer
                      sort
                  }
                  required
                  sort
              }

              contact_page { 
                  id 
                  header
                  description
                  button_text
                  default_phone_prefix
                  photo{
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                  }
                  form {
                      id
                      display
                      name
                      placeholder
                      type
                      required
                      sort
                  }
                  show_consultant
              }

              result_page {
                  id
                  hidden
                  auto_redirect
                  format
                  progress_bar_style
                  show_condition
                  show_points_max
                  show_points_total
                  results {
                      id
                      title
                      description
                      url
                      button_text
                      sort
                      photo {
                          id
                          filename
                          storage
                          unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                          hint
                          display_settings {
                              desktop {background_size horizontal_position vertical_position}
                              mobile {background_size horizontal_position vertical_position}
                          }
                      }
                      condition {
                          operator
                          value
                          from
                          to
                      }
                  }
              }

              offer_page {
                  id
                  deleted_at
                  photo {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                      display_settings {
                          desktop {background_size horizontal_position vertical_position}
                          mobile {background_size horizontal_position vertical_position}
                      }
                  }
                  mobile_photo {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                      display_settings {
                          mobile {background_size horizontal_position vertical_position}
                      }
                  }
                  header
                  description
                  button_text
                  hidden
                  ratio
                  before_contact_page
                  offers {
                      id
                      photo {
                          id
                          filename
                          storage
                          unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                          hint
                          display_settings {
                              desktop {background_size horizontal_position vertical_position}
                          }
                      }
                      title
                      subtitle
                      description
                      button_text
                      button_link
                      properties
                      conditions
                      hidden
                  }
              }

              finish_page {
                  id
                  hidden
                  header
                  description
                  format
                  photo {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                      display_settings {
                          desktop {background_size horizontal_position vertical_position}
                          mobile {background_size horizontal_position vertical_position}
                      }
                  }
                  mobile_photo {
                      id
                      filename
                      storage
                      unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                      hint
                      display_settings {
                          mobile {background_size horizontal_position vertical_position}
                      }
                  }
                  button_text
                  button_url
              }
          }
    }
`;
export const fragmentQuizzesDataForConstructorDesign = `
    fragment fragmentQuizzesDataForConstructorDesign on QuizPagination {
          data {
               id
               code
               name
               project_id
               is_shared
               viewer_permissions {
                   is_owner
                   is_collaborator
                   can_manage_quiz
                   can_copy
                   can_manage_integrations
                   can_view_crm
                   can_share
                   can_transfer
                   can_delete
                   can_publish
               }
               timezone
               domain
               points_min
               points_max
               contacts
               logotype{
                   id
                   filename
                   storage
                   unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                   path
                   type
                   size
                   hint
                   created_at
               }
               options { 
                   id
                   corners
                   theme
                   show_progress
                   lang
                   hide_label
                   auto_next
                   auto_redirect
                   auto_redirect_url
                   privacy_policy_request
                   show_back_button
                   custom_design
                   points {
                       enabled
                       show_each_page
                       formula
                   }

                   benefits {
                       start_page
                       questions
                       contact_page
                       finish_page
                   }
               }

               social_networks {
                   id
                   network_type
                   network_url
               }
                          
               benefits {
                   id
                   type
                   image {
                       id
                       filename
                       storage
                       unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                       hint
                   }
                   label
                   description
                   benefit
               }

               consultants {
                   id
                   name
                   job_title
                   created_at
                   votes
                   photo {
                       id
                       filename
                       storage
                       unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                       hint
                       display_settings {
                           desktop {background_size horizontal_position vertical_position}
                           mobile {background_size horizontal_position vertical_position}
                       }
                   }
                   display_conditions {
                       logic
                       answers {
                           question_id
                           logic
                           value
                       }
                   }
               }

               start_page{
                   id
                   hidden
                   format
                   photo {
                       id
                       filename
                       storage
                       unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                       hint
                       display_settings {
                           desktop {background_size horizontal_position vertical_position}
                           mobile {background_size horizontal_position vertical_position}
                       }
                   }
                   header
                   description
                   button_text
               }

               questions { 
                   id
                   hidden
                   answer_type
                   options {
                      ...on VariantProperties {
                          auto_next
                          display_mode
                          show_custom
                          multiple
                          view
                      }
                       ...on RangeProperties {
                           minimum
                           maximum
                           step
                           is_range
                           position_start
                           position_end
                       }
                       ... on SimplePageProperties{
                           additional_text
                       }
                       ...on RatingProperties {
                           count
                           display
                           border_style
                           color_ids
                           pack_id
                           size_id
                           titles
                       }
                      ...on CustomProperties {
                          placeholder
                          mask_id
                          display_mode_custom:display_mode
                      }
                      ... on TextareaProperties{
                          placeholder
                      }
                       ...on DateTimeProperties {
                           display_mode_datetime: display_mode
                           min_date
                           max_date
                           min_time
                           max_time
                           format
                           is24
                           is_range
                           prohibit_days_of_week
                       }
                       ...on MultiInputProperties {
                              display_options {
                                layout
                                columns
                              }
                              inputs {
                                config {
                                  mask_id
                                  label
                                  options {
                                    label
                                    value
                                    description
                                  }
                                }
                                key
                                placeholder
                                required
                                title
                                type
                                ui {
                                  sort
                                  hidden
                                }
                              }
                            }
                   }
                   display_conditions {
                       logic
                       answers {
                           question_id
                           logic
                           value
                       }
                   }
                   points_conditions {
                       logic
                       answers {
                           question_id
                           logic
                           value
                           points
                       }
                   }
                   placeholder
                   show_consultant
                   photo {
                       id
                       filename
                       storage
                       unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                       hint
                       display_settings {
                           desktop {background_size horizontal_position vertical_position}
                           mobile {background_size horizontal_position vertical_position}
                       }
                   }
                   video {
                       allow_fullscreen
                       autoplay
                       controls
                       ratio
                       url
                       enabled
                   }
                   text
                   description
                   variants { 
                       id
                       photo {
                           id
                           filename
                           storage
                           unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                           hint
                       }
                       answer
                       sort
                   }
                   required
                   sort
               }

               contact_page { 
                   id 
                   header
                   description
                   button_text
                   default_phone_prefix
                   photo{
                       filename
                       storage
                       unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                   }
                   form {
                       id
                       display
                       name
                       placeholder
                       type
                       required
                       sort
                   }
                   show_consultant
               }

               result_page {
                   id
                   hidden
                   auto_redirect
                   format
                   progress_bar_style
                   show_condition
                   show_points_max
                   show_points_total
               results {
                   id
                   title
                   description
                   url
                   button_text
                   sort
                       photo {
                           id
                           filename
                           storage
                           unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                           hint
                           display_settings {
                               desktop {background_size horizontal_position vertical_position}
                               mobile {background_size horizontal_position vertical_position}
                           }
                       }
                       condition {
                           operator
                           value
                           from
                           to
                       }
                   }
               }

               offer_page {
                   id
                   deleted_at
                   photo {
                       id
                       filename
                       storage
                       unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                       hint
                       display_settings {
                           desktop {background_size horizontal_position vertical_position}
                           mobile {background_size horizontal_position vertical_position}
                       }
                   }
                   header
                   description
                   button_text
                   hidden
                   ratio
                   before_contact_page
                   offers {
                       id
                       photo {
                           id
                           filename
                           storage
                           unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                           hint
                           display_settings {
                               desktop {background_size horizontal_position vertical_position}
                               mobile {background_size horizontal_position vertical_position}
                           }
                       }
                       title
                       subtitle
                       description
                       button_text
                       button_link
                       properties
                       conditions
                   }
               }

               finish_page {
                   id
                   hidden
                   header
                   description
                   format
                   photo {
                       id
                       filename
                       storage
                       unsplash_requirements { photoId imageUrl downloadLocation authorName authorUrl unsplashUrl attributionHtml }
                       hint
                       display_settings {
                           desktop {background_size horizontal_position vertical_position}
                           mobile {background_size horizontal_position vertical_position}
                       }
                   }
                   button_text
                   button_url
               }
          }
    }
`;

export const fragmentQuizzesPaginationBase = /* GraphQL */ `
 fragment fragmentQuizzesPaginationBase on QuizPagination {
    total
    per_page
    current_page
    from
    to
    last_page
    has_more_pages
    data {
      id
      code
      name
      domain
      project_id
      is_template
      is_deleted
      tags
      deleted_at
    }
 }`;

export const fragmentQuizzesForDeletedModal = /* GraphQL */ `
 fragment fragmentQuizzesForDeletedModal on QuizPagination {
    data {
      id
      code
      name
      domain
      deleted_at
    }
 }`;

export const fragmentQuizzesForTemplates = /* GraphQL */ `
 fragment fragmentQuizzesForTemplates on QuizPagination {
    data {
      id
      code
      name
      domain
      tags
    }
 }`;

export const fragmentQuizzesForTemplatesModal = /* GraphQL */ `
 fragment fragmentQuizzesForTemplatesModal on QuizPagination {
    data {
      id
      code
      domain
      is_template
      tags
      name
      start_page {
        description
        photo { filename }
      }
      options {
        lang
      }
    }
 }`;

export const fragmentQuizzesQuestionsForIntegrations = /* GraphQL */ `
 fragment fragmentQuizzesQuestionsForIntegrations on QuizPagination {
    data {
      id
      questions {
        id
        text
      }
    }
 }`;

export const fragmentQuizPointsRange = /* GraphQL */ `
 fragment fragmentQuizPointsRange on QuizPagination {
    data {
      id
      points_min
      points_max
    }
 }`;

export const fragmentQuizzesForWorkboard = /* GraphQL */ `
 fragment fragmentQuizzesForWorkboard on QuizPagination {
    data {
      id
      name
      code
      domain
      is_template
      updated_at
      created_at
      leads_not_provided_count
      leads_count
      project_id
      is_shared
      is_blocked
      viewer_permissions {
        is_owner
        is_collaborator
        can_manage_quiz
        can_copy
        can_manage_integrations
        can_view_crm
        can_share
        can_transfer
        can_delete
        can_publish
        owner {
          id
          email
          avatar
          nickname
        }
        inviter {
          id
          email
          avatar
          nickname
        }
        collaborator {
          id
          email
          avatar
          nickname
        }
      }
      options {
        id
      }
    }
 }`;
